import { api } from '../api.js';
import { navigate } from '../router.js';
import { toast } from '../utils/toast.js';

export async function renderResetPasswordPage({ root }) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';

  if (!token) {
    root.innerHTML = `
      <div class="auth-wrapper">
        <div class="auth-card">
          <h1>Ссылка неполная</h1>
          <p class="text-muted text-center">Не нашли токен сброса. Попроси новую ссылку через «Забыл пароль».</p>
          <div class="actions"><a class="btn" href="/forgot-password" data-link>Запросить ссылку</a></div>
        </div>
      </div>
    `;
    return;
  }

  root.innerHTML = `
    <div class="auth-wrapper">
      <form class="auth-card" id="reset-form">
        <h1>Новый пароль</h1>
        <p class="text-muted text-center" style="margin-top: -14px; margin-bottom: 20px;">
          Придумай новый пароль — минимум 8 символов.
        </p>
        <div class="form-error" id="form-error"></div>
        <div class="field">
          <label for="password">Новый пароль</label>
          <input type="password" id="password" required minlength="8" autocomplete="new-password" />
        </div>
        <div class="field">
          <label for="password2">Повтори</label>
          <input type="password" id="password2" required minlength="8" autocomplete="new-password" />
        </div>
        <div class="actions">
          <button type="submit" id="submit-btn">Поменять пароль</button>
        </div>
      </form>
    </div>
  `;
  const form = root.querySelector('#reset-form');
  const errEl = root.querySelector('#form-error');
  const btn = root.querySelector('#submit-btn');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errEl.textContent = '';
    if (form.password.value !== form.password2.value) {
      errEl.textContent = 'Пароли не совпадают';
      return;
    }
    btn.disabled = true;
    try {
      await api.auth.reset(token, form.password.value);
      toast('Пароль обновлён, теперь войди', { type: 'success' });
      navigate('/login');
    } catch (err) {
      if (err.status === 400) errEl.textContent = 'Ссылка просрочена или уже использована. Запроси новую.';
      else errEl.textContent = err.message || 'Не получилось поменять пароль';
      btn.disabled = false;
    }
  });
}
